import { render, staticRenderFns } from "./StatuteDataPending.vue?vue&type=template&id=4642a93a&"
import script from "./StatuteDataPending.vue?vue&type=script&lang=ts&"
export * from "./StatuteDataPending.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports